export default __webpack_public_path__ + "static/media/ISSO CLASS-7_SYLLABUS_2025-26.1e6a7a01.pdf";